module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0029.jpg?v=9da76943";